import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Slider from 'react-slick';
import * as commonActions from '../../../actions/common/common';
import { InfoAds } from "../adverts/infoAds";

class AdvertisementSlider extends Component {

    clickedAdvert = ( advertId, url, slotId ) => {
        const { clickedAdvert } = this.props;

        clickedAdvert( advertId, slotId );

        const win = window.open( url, '_blank');
        win.focus();
    };

    render() {
        const { sliderData, redirectTo, ads_position, top  } = this.props;
        const settings = {
            dots: false,
            arrows:  false,
            infinite: true,
            autoplay: Object.keys( sliderData ).length > 1,
            autoplaySpeed: 10000,
            slidesToShow: 1,
            slidesToScroll: 1,
            swipeToSlide: false,
            pauseOnHover: true,
        };

        const noBorder =
        {
            borderWidth: '0'
        }

        return (
            <div className={`homepage-slider adverts ${ ads_position === 'top' ? "slider-ads-top" : "slider-ads-bottom"}`}>
	            {
		            ads_position === 'top' ?
			            null : <InfoAds ads_position={ ads_position } />

	            }
                <Slider ref={ c => this.slider = c } { ...settings }>
                    {
                        Object.keys( sliderData ).map( ( slider, index ) => {
                            return (
                                <div key={ index }>
                                    <a onClick={ () => this.clickedAdvert( sliderData[ slider ].id, redirectTo || sliderData[ slider ].url, sliderData[ slider ].slot_id ) }>
                                        <img className={`img-responsive ${ noBorder}`}  src={ sliderData[ slider ].image } alt="banner ad for in touch networks conference" />
                                    </a>
                                    {
                                        sliderData[ slider ].tracker ?
                                            <img width="1" height="1" alt="Advertisement" src={ sliderData[ slider ].tracker.replace( '[timestamp]', Math.round((new Date()).getTime() / 1000) ) } />
                                            :
                                            null
                                    }

                                </div>
                            );
                        } )
                    }
                </Slider>
	            {
		            ads_position === 'top' ?
			            <InfoAds ads_position={ ads_position } /> : null
	            }
            </div>
        );
    }

}

AdvertisementSlider.propTypes = {
    sliderData: PropTypes.array.isRequired,
};

const mapStateToProps = ( state ) => {
    return {
        url: state.common.url,
    };
};

const mapDispatchToProps = ( dispatch ) => {
    return {
        clickedAdvert: ( advertId, slotId ) => dispatch( commonActions.clickedAdvert( advertId, slotId ) ),
    };
};

export default connect( mapStateToProps, mapDispatchToProps )( AdvertisementSlider );



// WEBPACK FOOTER //
// src/client/components/common/elements/AdvertisementSlider.js